import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { translations, Language, TranslationKey } from '@/lib/i18n';

interface LanguageStore {
  language: Language;
  setLanguage: (lang: Language) => void;
}

// Custom storage that handles Chrome issues
const storage = createJSONStorage(() => {
  try {
    // Test if localStorage is accessible
    const test = '__test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return localStorage;
  } catch (e) {
    // Fallback to in-memory storage if localStorage is not available
    const memoryStorage: Storage = {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
      clear: () => {},
      key: () => null,
      length: 0,
    };
    return memoryStorage;
  }
});

export const useLanguage = create<LanguageStore>()(
  persist(
    (set) => ({
      language: 'fr',
      setLanguage: (language) => set({ language }),
    }),
    {
      name: 'clevia-language',
      storage: storage,
    }
  )
);

export function useTranslation() {
  const { language, setLanguage } = useLanguage();

  const t = (key: TranslationKey): string => {
    return translations[language][key] || key;
  };

  return { t, language, setLanguage };
}
